import { Reveal } from "./Reveal";
import { SERVICES } from "../../data/site";
import { ArrowUpRight } from "lucide-react";

export default function Services() {
  return (
    <section id="servicos" data-testid="services-section" className="relative py-28 sm:py-36 bg-surface/30 border-y border-white/10">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-coral">
              / O que fazemos
            </span>
            <h2 className="mt-5 font-display font-extrabold tracking-tighter text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
              Portfólio completo<br />de engenharia elétrica.
            </h2>
          </div>
          <p className="text-muted-fg max-w-sm text-base leading-relaxed">
            Do diagnóstico à execução com ART, cuidamos de toda a infraestrutura elétrica
            do seu condomínio com equipe própria e qualificada.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-l border-t border-white/10">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal
                key={s.title}
                delay={(i % 3) * 0.06}
                data-testid={`service-card-${i}`}
                className="group relative border-r border-b border-white/10 p-8 sm:p-10 transition-colors duration-500 hover:bg-ink"
              >
                <div className="flex items-start justify-between mb-8">
                  <span className="grid place-items-center w-12 h-12 border border-white/15 text-coral group-hover:bg-coral group-hover:text-white group-hover:border-coral transition-colors duration-500">
                    <Icon size={22} strokeWidth={1.8} />
                  </span>
                  <span className="font-mono text-[10px] uppercase tracking-widest text-muted-fg border border-white/10 px-2 py-1">
                    {s.tag}
                  </span>
                </div>
                <h3 className="font-display font-bold text-white text-2xl mb-3 flex items-center gap-2">
                  {s.title}
                  <ArrowUpRight size={18} className="text-coral opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-500" />
                </h3>
                <p className="text-muted-fg text-sm leading-relaxed">{s.desc}</p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
